import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { productAPI } from '../../services/api';

interface ProductMedia {
  id: string;
  name: string;
  sequence: string;
}

interface ProductDetail {
  id: number;
  lable: string;
  data: string;
}

interface GroupPrice {
  group_id: string;
  groupprice: number;
}

interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  availablequantity: number;
  minimumorderquantity: number;
  categoryId: string;
  productstatus: number;
  productdetails: ProductDetail[];
  productmedia: ProductMedia[];
  mainGroupPrice: GroupPrice[];
  groupprices: GroupPrice[];
  productvariation: any[];
  variationconfig: any[];
  productunit: string;
  videourllink: string;
  productbrochure: string;
  other: any;
  producttypeId: number;
  inInquiry: boolean;
  sellcounter: number;
  expecteddays: number;
  created: string;
  modified: string;
  createdby: string;
  modifiedby: string | null;
  deletedAt: string | null;
  masterdetailId: string;
}

interface ProductsState {
  products: Product[];
  loading: boolean;
  error: string | null;
  pagination: {
    page: number;
    items_per_page: number;
    total: number;
  };
}

const initialState: ProductsState = {
  products: [],
  loading: false,
  error: null,
  pagination: {
    page: 1,
    items_per_page: 10,
    total: 0,
  },
};

// Fetch products with pagination and filters
export const fetchProducts = createAsyncThunk(
  'products/fetchProducts',
  async (params?: { 
    page?: number; 
    items_per_page?: number; 
    search?: string; 
    'where[productstatus]'?: number;
    sort?: string;
  }) => {
    const response = await productAPI.getProductsV2(params);
    
    // Handle new API response structure - same as categories
    if (response.data && response.data.data && Array.isArray(response.data.data)) {
      return {
        products: response.data.data,
        pagination: response.data.payload || {
          page: 1,
          items_per_page: 10,
          total: 0,
        }
      };
    } else if (Array.isArray(response.data)) {
      return {
        products: response.data,
        pagination: {
          page: 1,
          items_per_page: response.data.length,
          total: response.data.length,
        }
      };
    } else {
      return {
        products: [],
        pagination: {
          page: 1,
          items_per_page: 10,
          total: 0,
        }
      };
    }
  }
);

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        // Handle the response structure - same as categories
        if (action.payload && action.payload.products && Array.isArray(action.payload.products)) {
          state.products = action.payload.products;
          state.pagination = action.payload.pagination;
        } else {
          // Fallback to empty array
          state.products = [];
          state.pagination = {
            page: 1,
            items_per_page: 10,
            total: 0,
          };
        }
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch products';
      });
  },
});

export default productsSlice.reducer; 